import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { Organization } from 'src/app/modules/user-profile/models/role-request.models';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';

@Component({
    selector: 'app-multi-org-filter',
    imports: [CommonModule, FormsModule, NgSelectModule, NgxSpinnerModule, SpinnerComponent],
    templateUrl: './multi-org-filter.component.html',
    styleUrls: ['./multi-org-filter.component.css']
})
export class MultiOrgFilterComponent implements OnInit {
  private roleRequestService = inject(RoleRequestService);
  private spinner = inject(NgxSpinnerService);

  readonly showRequired = input<boolean>(undefined);
  readonly isRoleAdmin = input<boolean>(undefined);
  readonly selectedOrgChange = output<Organization>();

  selectedOrganization: Organization;
  organizations: Organization[] = [];
  userRoles = [];

  ngOnInit(): void {
    this.getOrganizationsRoles();
  }

  getOrganizationsRoles(): void {
    this.spinner.show('multi-org');
    this.roleRequestService.getRolesByPersonKey(this.roleRequestService.getLoggedInPersonKey()).subscribe((userRolesResponse: any) => {
      this.organizations = userRolesResponse.personOrgRole.personOrgRoleList.map(
        x => {
          x.orgName = x.organization.name;
          x.orgKey = x.organization.key;
          x.irn = x.organization.irn;
          x.orgTypeKeys = x.organization.orgTypeKeys;
          return x;
        }
      );
      this.organizations = this.organizations.filter((org, index, self) =>
        index === self.findIndex((o) => o.irn === org.irn)
      );
      this.organizations.sort((a, b) => a.orgName?.localeCompare(b.orgName));
      this.userRoles = userRolesResponse.personOrgRole.personOrgRoleList.map(x => {
        x.roleName = x.role.name;
        x.roleKey = x.role.key;
        return x;
      });

      this.spinner.hide('multi-org');
      this.setDefaultValues();

      if (!this.selectedOrganization && this.organizations?.length === 1) {
        this.selectedOrganization = this.organizations[0];
        this.onChangeOrg();
      } else if (!this.selectedOrganization && this.organizations?.length > 1) {
        const hasDewRole = this.userRoles.some(role => role.roleKey === 1100295 /*employee*/ 
          || role.roleKey === 1100296 /* CONTRACTOR */ 
          || role.roleKey === 1248771 /*User profile admin*/
          );
        // if org has dew org, set it as selected organization or else the first one
        this.selectedOrganization = hasDewRole && this.hasDewOrg(this.organizations) ? 
                                          this.organizations.find(x => x.irn === '050765' /*oeds*/) : 
                                          this.organizations.filter(x => x.irn !== '050765' /*oeds*/)?.[0];
        this.onChangeOrg();
      }
      else {
        this.updateFilters();
      }
    }, err => {
      this.spinner.hide('multi-org');
    });
  }

  

  // Set default values from the service if they exist
  setDefaultValues(): void {
    const defaultValues = this.roleRequestService.multiOrgFilters;
    this.selectedOrganization = this.organizations
      .find(x => x.irn == defaultValues.selectedOrganization?.irn
        || x.irn == (defaultValues.selectedOrganization as any)?.orgIrn);
  }

  // Handle organization change and set the appropriate role group
  onChangeOrg(): void {
    this.updateFilters();
    this.selectedOrgChange.emit(this.selectedOrganization);
  }

  // Update role group and organization filters in the service
  updateFilters(): void {
    this.roleRequestService.multiOrgFilters = {
      selectedOrganization: this.selectedOrganization,
      isDewOrg: this.hasDewOrg(this.organizations),
      hasNoOrgs: this.organizations.length === 0,
      isHomeFilter: true,
      userRoles: this.userRoles
    };
  }

  hasDewOrg(userOrgs: Organization[]) {
    return userOrgs?.some(org => org.irn === '050765');
  }

}
